"use strict";
var PopStateType_1 = require('../PopStateType');
var Options_1 = require('../Options');
var PopOver_1 = require('../PopOver');
var closest = require('closest');
var Pop = (function () {
    function Pop(el, trigger) {
        this.targetEl = el;
        this.trigger = trigger;
        this.opts = Options_1.default.fromElement(el);
        this.state = PopStateType_1.default.HIDDEN;
        this.isPinned = false;
        this.parentPop = null;
        this.childPops = [];
        var target = this._buildPopOver(this.opts.html || this.opts.text);
        this.popOver = (new PopOver_1.default(target, trigger));
    }
    Pop.prototype._buildPopOver = function (htmlOrText) {
        var content = this.opts.html || this.opts.text;
        var el = document.createElement('div');
        el.setAttribute('class', 'pop-content');
        el.innerHTML = content;
        return el;
    };
    return Pop;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Pop;
